module.exports = __webpack_public_path__ + "static/media/logo-directLogo.720dd897.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/logo-directLogo.png
// module id = 498
// module chunks = 0